import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsRedemptionTab = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen_name: 'Sortezinha:Resgate',
    product_area: 'Resgate',
    product: 'capitalização',
    step: '1',
    flow: 'prateleira',
    ...params,
  })
}

export const analyticsTooltipTag = ({ value }: { value: string }) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CONDICOES_GERAIS, {
    ref_figma: '76',
    screen: 'resgate',
    ref_type: 'tooltip',
    action_id: 'tooltip resgate',
    value,
    currency: 'BRL',
    product: 'capitalização',
    flow: 'resgate',
  })
}

export const analyticsOpenBSTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.INFO_LEGAIS, {
    ref_figma: '77',
    screen: 'resgate',
    ref_type: 'link das sortezinhas',
    content_action: 'toque',
    action_id: 'mostrar sortezinhas',
    product: 'capitalização',
    flow: 'prateleira',
  })
}

export const analyticsRepurchaseRedirectTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '98',
    screen: 'resgate',
    ref_type: 'botão',
    action_id: 'resgatar nova sortezinha',
    content_action: 'toque',
    product: 'capitalização',
    flow: 'resgate',
  })
}

export const analyticsRedeemValueRedirectTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '99',
    screen: 'resgate',
    ref_type: 'botão',
    action_id: 'resgatar valor',
    content_action: 'toque',
    product: 'capitalização',
    flow: 'resgate',
  })
}

export const analyticsRedemptionBannerTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '83',
    screen: 'resgate',
    ref_type: 'banner',
    action_id: 'Renove suas chances',
    content_action: 'toque',
    product: 'capitalização',
    flow: 'resgate',
  })
}
